/**
 * Mirrors OctaPOS.Domain.Organization.Permission.
 *
 * These values MUST stay in step with the C# enum — they are the same bitmask travelling in
 * the token. They exist here only to decide what the UI shows; every one of them is enforced
 * again on the server, so a tampered client gains nothing.
 */
export const Permission = {
  None: 0,
  Refund: 1 << 0,
  VoidSale: 1 << 1,
  Discount: 1 << 2,
  EditPrice: 1 << 3,
  OpenDrawer: 1 << 4,
  ViewReports: 1 << 5,
  ManageStock: 1 << 6,
  RecordWaste: 1 << 7,
  ManageUsers: 1 << 8,
  ManageSettings: 1 << 9,
  ManageCustomers: 1 << 10,
  RecordExpense: 1 << 11,
  ChangeExchangeRate: 1 << 12,
  ManageSafe: 1 << 13,
  ManageCatalog: 1 << 14,
  CloseShift: 1 << 15,
  ReverseTransaction: 1 << 16,
  ViewDashboard: 1 << 17,
} as const

export type PermissionName = keyof typeof Permission
export type PermissionValue = (typeof Permission)[PermissionName]

export function can(mask: number, permission: PermissionValue): boolean {
  return (mask & permission) === permission
}

export function canAny(mask: number, ...permissions: PermissionValue[]): boolean {
  return permissions.some((permission) => can(mask, permission))
}
